/* exported initNavigation */
var initNavigation = function () {
  'use strict';
  //desktop navigation
  $('#categories, #mobilecategories, #tags, #mobiletags').each(function (index, element) {
    //init chosen
    $(element).chosen({
      width: '100%',
      no_results_text: $(element).data('no-results'),
      display_disabled_options: false
    }).change(function () {
      //navigate on select
      var url = $(this).val();
      var $order = $('#orderby');
      if($order.length !== 0 && $order.val() !== '') {
        url = url + '?' + $order.closest('form').serialize();
      }
      window.location.href = url;
    });
  });
  $('#orderby').chosen({
    width: '100%'
  }).change(function(){
    $(this).closest('form').submit();
  });
};

var initToggleMenu = function () {
  if ($('.noBstHeader').length) {
      function toggleMenu() {
      $('#mobile-nav').toggle();
      $('#mobile-search').toggle();
      $('#navi-backlayer').toggle();
    };

    $('#menu-icon').bind('click', function () {
      toggleMenu();
    });

    $('#nav li:has(div)').doubleTapToGo();
  }
};

;(function( $, window, document, undefined )
{
  $.fn.doubleTapToGo = function( params )
  {
    if( !( 'ontouchstart' in window ) &&
        !navigator.msMaxTouchPoints &&
        !navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;

    this.each( function()
    {
      var curItem = false;

      $( this ).on( 'click', function( e )
      {
        var item = $( this );
        if( item[ 0 ] != curItem[ 0 ] )
        {
          e.preventDefault();
          curItem = item;
        }
      });

      $( document ).on( 'click touchstart MSPointerDown', function( e )
      {
        var resetItem = true,
            parents	  = $( e.target ).parents();

        for( var i = 0; i < parents.length; i++ )
          if( parents[ i ] == curItem[ 0 ] )
            resetItem = false;

        if( resetItem )
          curItem = false;
      });
    });
    return this;
  };
})( jQuery, window, document );
